import { http } from './http';
import { baseURL, moderationEndpoint } from './wpConfig';
import { UserCredentials } from './wpAuth';
import { FacebookVoteResponse, FacebookPromoteResponse } from './types';

export const toggleFacebookVote = (userCredentials: UserCredentials, postId: number): Promise<FacebookVoteResponse> => {
    const endPoint: string = baseURL + moderationEndpoint + "/facebook/vote/" + postId;
    return http.post<FacebookVoteResponse>(endPoint, {}, { auth: userCredentials });
};

export const toggleFacebookPromotion = (userCredentials: UserCredentials, postId: number): Promise<FacebookPromoteResponse> => {
    const endPoint: string = baseURL + moderationEndpoint + "/facebook/promote/" + postId;
    return http.post<FacebookPromoteResponse>(endPoint, {}, { auth: userCredentials });
};

export const addOrthoCorrection = (userCredentials: UserCredentials, postId: number, correctionText: string): Promise<{ status: string }> => {
    const endPoint: string = baseURL + moderationEndpoint + "/ortho/" + postId;
    return http.post<{ status: string }>(endPoint, { ortho_correction: correctionText }, { auth: userCredentials });
};

